import React from 'react'
import PropTypes from 'prop-types'
import './styles.scss'

const Radio = ({
  className,
  value,
  name,
  label,
  onChange,
  checked,
  required,
  invalid,
}) => {
  return (
    <div className={`radio--custom ${className || ''}`}>
      <input
        type="radio"
        name={name}
        value={value}
        onChange={onChange}
        checked={checked}
        required={required}
        disabled={invalid}
        className="radio--custom-input"
        id={name}
      />

      <label htmlFor={name} className="radio--custom-label">
        {label}
      </label>
    </div>
  )
}

Radio.propTypes = {
  className: PropTypes.string,
  value: PropTypes.any,
  name: PropTypes.string,
  label: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  required: PropTypes.bool,
  invalid: PropTypes.bool,
}

export default Radio